export default __webpack_public_path__ + "static/unitedincome-c38aa5176706707058e37dcf5ff5b915.mp4";